import React, { useState } from 'react';
import ImagePicker from './ImagePicker';
import FileUploader from '@jumbo/Dashboards/Media/FileUploader';

export default function ImgaeSelector({ puzzleSource, setPuzzleSource }) {
  const [openFileUploader, setOpenFileUploader] = useState(false);
  return (
    <>
      <ImagePicker
        cover={puzzleSource}
        handlePick={() => setOpenFileUploader(true)}
        handleRevome={() => setPuzzleSource('')}
        previewStyles={{ marginInline: 'auto', marginBlock: '20px', width: '200px', height: '200px' }}
        placeHolderStyles={{ marginInline: 'auto', marginBlock: '20px', width: '200px', height: '200px' }}
      />
      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={selected => setPuzzleSource(selected)}
        selectedItem={puzzleSource}
        imageSelector={true}
      />
    </>
  );
}
